import React from "react";
import { getMerchantConfig } from "features/config/configSlice";
import { useSelector } from "react-redux";
import { StyledLoadingError } from "./styled";

function LoadingError({
  title = "Something went wrong",
  message = "We couldn't load this section.",
  actionLabel = "Retry",
  onRetry = () => window.location.reload(),
  minHeight,
  marginTop,
  padding,
}) {
  const merchantConfig = useSelector(getMerchantConfig);

  return (
    <StyledLoadingError
      $marginTop={marginTop}
      $minHeight={minHeight}
      $padding={padding}
      $primaryColor={merchantConfig.primary_theme_color}
      $rounded={merchantConfig.use_rounded_edge_buttons}
      $secondaryColor={merchantConfig.secondary_theme_color}
    >
      <span className="loading-error-icon">😔</span>
      <h3 className="loading-error-title">{title}</h3>
      <p className="loading-error-message">{message}</p>
      <button className="loading-error-action" type="button" onClick={onRetry}>
        {actionLabel}
      </button>
    </StyledLoadingError>
  );
}

export default LoadingError;
